import _ from "lodash";

export default {
    namespaced: true,
    state: {
        followers: [],
        followings: [],
        contacts: [],
        info: {
            initialized: false,
            status: {
                created: false,
                ready: false,
                dead: false,
                status: "UNKNOWN",
                error: undefined,
                purchased: false,
            },
        },
    },
    getters: {
        isHealthy: (state) => {
            const s = state.info.status;
            return state.info.initialized && s.ready && !s.dead;
        },
    },
    mutations: {
        setContacts(state, payload) {
            state.contacts = payload;
        },
        setInfo(state, status) {
            const old = Object.keys(status).reduce((acc, cur) => {
                acc[cur] = state.info.status[cur];
                return acc;
            }, {});
            if (!_.isEqual(status, old)) {
                state.info.status = status;
            }
            if (!state.info.initialized) state.info.initialized = true;
        },
        changePurchaseStatus(state, payload) {
            state.info.status.purchased = payload;
        },
    },
    actions: {},
};
